// extracted by mini-css-extract-plugin
export default {"TextInput":"njOOn__TextInput","textInput":"njOOn__TextInput","TextInputFocusBorder":"yeF7F__TextInputFocusBorder","textInputFocusBorder":"yeF7F__TextInputFocusBorder"};